//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/plates'
import { TABS, TYPE_CLASS } from '../facilities_const'
export default {
    props: {
        pid: [Number, String],
        region: Array
    },
    data () {
        return {
            tabs: TABS,
            type: '交通',
            items: {},
            show_detail: true
        }
    },
    mounted () {
        this.$nextTick(()=>{
            this.getData()
        })

    },
    methods: {
        openDetail () {
            wx.navigateTo({
                url: `/packageB/plates/around_facilities?id=${this.pid}`
            })
        },
        changeTab (type) {
            this.type = type
            this.getData()
        },
        async getData () {
            this.items = []
            this.markers = []
            const { items } = await Service.getFacilities(this.pid, this.type)

            this.items = items.reduce((prev, item) => {
                item.classname = TYPE_CLASS[item.subcategory]
                if (!prev[item.subcategory]) {
                    prev[item.subcategory] = {
                        title: item.subcategory,
                        children: []
                    }
                }
                prev[item.subcategory].children.push(item)
                return prev
            }, {})
            this.show_detail = Object.keys(this.items).length > 0
        }
    }
}
